export default __webpack_public_path__ + "9a5307c6a873be14724d001df3852387.webp";